import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { goodsService } from 'shared/src/api';

export const useGoodsRelatedOutfit = () => {
  const goodsSno = useGoodsSno();

  return useSuspenseQuery({
    queryKey: queryKey.goodsRelatedOutfit(goodsSno),
    queryFn: () => goodsService.getRelatedOutfits(goodsSno),
  });
};
